var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KCheckbox',{attrs:{"label":`selectedString = ${_vm.selectedString}`,"value":'String'},model:{value:(_vm.selectedString),callback:function ($$v) {_vm.selectedString=$$v},expression:"selectedString"}})
}
var staticRenderFns = []

export { render, staticRenderFns }